import AuthService from "../services/AuthService";

const RenderOnLoggedIn: React.FC<{}> = ({ children }): any => (AuthService.isLoggedIn()) ? children : null;

export default RenderOnLoggedIn;
